export default __webpack_public_path__ + "static/media/VectortintedMapSearch.4c1e87a1.svg";